exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Zp9LP4U0L7SnkdjEL7cx3{display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] ._3V6hFwnP__NS9AML0Op08M,html[dir] .Zp9LP4U0L7SnkdjEL7cx3{margin-top:20px}html[dir=ltr] ._3V6hFwnP__NS9AML0Op08M{margin-right:16px}html[dir=rtl] ._3V6hFwnP__NS9AML0Op08M{margin-left:16px}html[dir] ._1U2ExlEw63em8hmRW4l00P{margin-top:20px}html[dir=ltr] ._1U2ExlEw63em8hmRW4l00P{margin-right:16px}html[dir=rtl] ._1U2ExlEw63em8hmRW4l00P{margin-left:16px}html[dir] ._1bHdWl1xrNfhhBiMiAgMN7{margin-top:20px}", ""]);

// exports
exports.locals = {
	"ServicesTestSection": "Zp9LP4U0L7SnkdjEL7cx3",
	"createButton": "_3V6hFwnP__NS9AML0Op08M",
	"deleteButton": "_1U2ExlEw63em8hmRW4l00P",
	"getButton": "_1bHdWl1xrNfhhBiMiAgMN7"
};